<template>
  <div class="hello">
    <b-container>
      <b-row>
        <b-col>
          <h1>Uppskriftavél brew.is</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h2>Uppskriftin þín</h2>
          <p>Uppskrift í textaformi. Ath þyngd og svo nafn á hráefni. Engar mælieiningar.</p>
          <b-form-textarea
            placeholder="4.5 Pale Ale"
            rows="8"
            max-rows="16"
            v-model.lazy="$root.state.recipeText"
          ></b-form-textarea>
          <b-button variant="primary" @click="processText">Uppskrift í pöntun</b-button><br />
          <transition name="fade">
            <div v-if="cartTotal > 0">
              <h2>Uppskriftin þín</h2>
              Farðu vel yfir uppskriftina hér fyrir neðan - magntölur og hráefni geta skolast vegna t.d. innsláttarvilla.
              <b-table small :items="$root.state.recipe" :fields="recipeFields">
                <template v-slot:cell(type)="data">
                  <span v-if="data.item.category < 5">Korn</span>
                  <span v-else-if="data.item.category == 8">Ger</span>
                  <span v-else-if="data.item.category == 5">Humall</span>
                  <span v-else>Annað</span>
                </template>
                <template v-slot:cell(qty)="data">
                  {{ data.item.qty }} <span v-if="data.item.category < 5">kg</span><span v-else>stk</span>
                </template>
                <template v-slot:cell(name)="data">
                  <b-form-select
                    v-model="recipeAlternativesSelected[data.index]"
                    :options="recipeAlternatives[data.index]"
                    @change="recipeChange">
                  </b-form-select>

                  <span v-if="data.item.score > 0.06" class="dot warningdot"></span>
                </template>
                <template v-slot:cell(stock)="data">
                  <span v-if="data.item.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span>
                </template>
                <template v-slot:cell(price)="data">
                  {{ Math.ceil(data.item.price * data.item.qty) }}
                </template>
                <template v-slot:foot(price) v-if="cartTotal > 0"><span>{{ cartTotal }}</span></template>
              </b-table>
              <p v-if="outOfStock">Vörur merktar <span class="dot errordot"></span> eru ekki til á lager. Þú getur sent pöntunina inn, en þá skiptum við hráefninu út fyrir annað sambærilegt.</p>
              <span>{{ cartTotal }} krónur samtals</span><br>
              <span v-if="recipeGrainQty == 0" class="text-danger">Það er ekkert korn í þessari uppskrift...</span><br>
              <b-button variant="primary" @click="confirmOrder" :disabled="recipeCheck">Panta uppskrift</b-button>
              <hr />
            </div>
          </transition>
          <h3>Nokkrir punktar</h3>
          <ul>
            <li>Uppskriftavélin reynir að leiðrétta innsláttar- og stafsetningarvillur á hráefni. Farðu vel yfir uppskriftina áður en þú sendir hana inn.</li>
            <li>Vélin skiptir út hráefnum fyrir sambærilegt þegar viðkomandi hráefni er ekki í boði, eða ef það heitir annað hjá mér. T.d. Crystal 60 er sama og Caramunich III</li>
            <li>Þú þarft samt að fara vel yfir áður en þú sendir uppskriftina inn. Stundum getur rangt hráefni komið inn og þá þarf að lagfæra það.</li>
            <li>Flestir humlar eru í 50gr einingum. 1 í magn við humal þýðir ein pakkning - 50gr. Það er ekki hægt panta t.d. 0.5 af humlum og geri.</li>
            <li>Ef þú finnur bögg eða villu í uppskriftarvélinni sem veldur lægra verði en eðlilega þá stendur venjulega verðið. Endilega láttu mig vita af villunni samt :)</li>
            <li>Ef þú vilt panta fleiri en eina uppskrift þá pantarðu eina uppskrift og ferð svo aftur á síðuna til að panta aðra</li>
            <li>Gert er ráð fyrir að allt korn sé malað</li>
            <li>Ef þig vantar ráðgjöf með t.d. humla eða ger, endilega sendu inn korn uppskriftina og rest er hægt að græja þegar þú sækir.</li>
            <li>Best er að panta uppskriftir fyrir hádegi, eða deginum áður en þú sækir.</li>
          </ul>
        </b-col>
        <b-col lg="6">
          <h2>Hráefni í boði</h2>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-1 variant="info">Korn</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <!-- Accordion korn -->
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block href="#" v-b-toggle.accordionk-1 variant="info">Grunnmalt</b-button>
                    </b-card-header>
                    <b-collapse id="accordionk-1" visible accordion="korn-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li v-for="y in getCat([44])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }} </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block href="#" v-b-toggle.accordionk-2 variant="info">Kristal / Karamellumalt</b-button>
                    </b-card-header>
                    <b-collapse id="accordionk-2" accordion="korn-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li v-for="y in getCat([45])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }} </li>
                          </ul>

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block href="#" v-b-toggle.accordionk-3 variant="info">Ristað korn</b-button>
                    </b-card-header>
                    <b-collapse id="accordionk-3" accordion="korn-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li v-for="y in getCat([46])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }} </li>
                          </ul>

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block href="#" v-b-toggle.accordionk-5 variant="info">Annað korn</b-button>
                    </b-card-header>
                    <b-collapse id="accordionk-5" accordion="korn-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          <ul>
                            <li v-for="y in getCat([47])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }} </li>
                          </ul>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!-- Accordion korn -->
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-2 variant="info">Humlar</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li v-for="y in getCat([36])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }} </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-3 variant="info">Ger</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li v-for="y in getCat([37])" :key="y.name"><span v-if="y.quantity < 1" class="dot errordot"></span><span v-else class="dot greendot"></span> {{ y.name }}</li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.accordion-0 variant="info">Uppskriftir</b-button>
            </b-card-header>
            <b-collapse id="accordion-0" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li>APA / IPA
                      <ul>
                        <li @click="$root.state.recipeName = 'Bee Cave'; $root.state.recipeText = '3.6 pale ale\n0.9 vienna\n0.22 carahell\n1 cascade\n1 us-05'">Bee Cave APA</li>
                        <li @click="$root.state.recipeName = 'Tri-Centennial'; $root.state.recipeText = '5 pale ale\n0.38 munich i\n0.16 carapils\n0.16 caramunich ii\n3 centennial\n1 s-04'">Tri-Centennial IPA</li>
                        <li @click="$root.state.recipeName = 'Fresh Squeezed'; $root.state.recipeText = '4.85 pale ale\n0.54 caramunich iii\n0.26 munich i\n2 citra\n2 mosaic\n1 nottingham'">Fresh Squeezed IPA</li>
                        <li @click="$root.state.recipeName = 'New England IPA'; $root.state.recipeText = '4 pilsner\n1 haframjöl\n0.4 hveitiflögur\n2 citra\n2 mosaic\n1 idaho #7\n1 centennial\n1 el dorado\n1 s-04'">New England IPA</li>
                        <li @click="$root.state.recipeName = 'Two Hearted'; $root.state.recipeText = '4.75 maris otter\n0.89 vienna\n0.2 carapils\n0.2 carared\n2 centennial\n1 cascade\n1 us-05'">Bell's Two Hearted IPA</li>
                        <li @click="$root.state.recipeName = 'Zombie Dust'; $root.state.recipeText = '4.85 pale\n0.45 munich i\n0.2 caramunich ii\n0.2 melanoidin\n0.2 carapils\n0.2 acidulated\n5 citra\n1 s-04'">Zombie Dust IPA</li>
                        <li @click="$root.state.recipeName = 'Vivien Leigh'; $root.state.recipeText = '5 pale ale\n 0.35 vienna\n0.17 caramunich iii\n3 galaxy\n1 us-05'">Vivien Leigh IPA</li>
                        <li @click="$root.state.recipeName = 'Lítill Léttur'; $root.state.recipeText = '4.5 pilsner\n0.38 haframjöl\n0.25 carapils\n0.12 carahell\n1 columbus\n1 Sabro\n1 citra\n1 us-05'">Lítill léttur APA</li>
                      </ul>
                    </li>
                    <li>Belgískir
                      <ul>
                        <li @click="$root.state.recipeName = 'Blonde'; $root.state.recipeText = '3.75 pale ale\n0.35 wheat\n0.22 vienna\n0.11 acidulated\n1 nugget\n1 abbaye'">Blonde</li>
                        <li @click="$root.state.recipeName = 'Dubbel'; $root.state.recipeText = '4.5 pilsner\n0.5 caramunich ii\n0.5 special w\n0.5 wheat\n1 celeia\n1 abbaye'">Dubbel</li>
                        <li @click="$root.state.recipeName = 'Hvítur Sloppur'; $root.state.recipeText = '1.75 pilsner\n1.75 wheat\n0.28 munich i\n1 hersbrucker\n1 t-58'">Hvítur sloppur wit hveitibjór</li>
                        <li @click="$root.state.recipeName = 'Saison DuBle'; $root.state.recipeText = '3 pilsner\n1.25 wheat\n0.22 vienna\n0.11 acidulated\n1 magnum\n1 saaz\n1 belle saison'">Saison DuBle</li>
                      </ul>
                    </li>
                    <li>Enskir
                      <ul>
                        <li @click="$root.state.recipeName = 'Hafra Porter'; $root.state.recipeText = '4.25 pilsner\n0.35 caramunich 2\n0.3 carapils\n0.26 haframjöl\n0.2 caraaroma\n0.2 carafa special i\n0.2 carafa special iii\n1 fuggles\n1 golding\n 1 nottingham'">Hafra Porter</li>
                        <li @click="$root.state.recipeName = 'Boat Bitter'; $root.state.recipeText = '4 maris otter\n0.1 special w\n1 east kent golding\n1 s-04'">Boat Bitter</li>
                        <li @click="$root.state.recipeName = 'Þurrstútur'; $root.state.recipeText = '3 pale ale\n0.6 byggflögur\n0.4 roasted barley\n1 east kent golding\n1 s-04'">Þurrstútur Dry Stout</li>
                      </ul>
                    </li>
                    <li>Lager
                      <ul>
                        <li @click="$root.state.recipeName = 'Vienna Lager'; $root.state.recipeText = '4.31 vienna\n0.11 melanoidin\n0.06 carapils\n0.06 carafa special iii\n1 mittelfruh\n2 w34/70'">Vienna Lager</li>
                        <li @click="$root.state.recipeName = 'Tékkneskur Pilsner'; $root.state.recipeText = '4.25 pilsner\n0.3 carapils\n1 magnum\n1 saaz\n2 w34/70'">Tékkneskur Pilsner</li>
                      </ul>
                    </li>
                    <li>Sterkir
                      <ul>
                        <li @click="$root.state.recipeName = 'Big Bad BeeDub'; $root.state.recipeText = '8.47 pale ale\n0.51 carahell\n0.34 special w\n0.06 caraaroma\n3 columbus\n2 us-05'">Big Bad BeeDub Barleywine</li>
                        <li @click="$root.state.recipeName = 'Kryddaður Vetrar'; $root.state.recipeText = '5 pilsner\n3 munich i\n0.3 special w\n0.1 carafa special iii\n1 nugget\n2 us-05'">Kryddaður vetrarbjór</li>
                      </ul>
                    </li>
                    <li>Annað
                      <ul>
                        <li @click="$root.state.recipeName = 'Cream Ale'; $root.state.recipeText = '2.48 pale ale\n0.83 flaked maize\n0.21 flaked rice\n1 magnum\n1 us-05'">Cream Ale - Cream of Three Crops</li>
                        <li @click="$root.state.recipeName = 'Súrmundur Valtýss'; $root.state.recipeText = '2.2 pale\n2 wheat\n1 magnum\n1 us-05'">Súrmundur Valtýss ávaxta súrbjór</li>
                      </ul>
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal ref="confirmModal" hide-footer title="Staðfesta pöntun" >
      <confirm-recipe-dialog @exit="hideModal" />
    </b-modal>
    <b-modal ref="recipeModal" id="recipeModal" hide-footer title="Uppskrift" size="lg">
      <recipe @exit="$refs['recipeModal'].hide()" :recipe_id="$route.params.id" />
    </b-modal>
  </div>
</template>

<script>
import Fuse from 'fuse.js'

import ConfirmRecipeDialog from './ConfirmRecipeDialog.vue'
import Recipe from './Recipe.vue'

export default {
  components: { ConfirmRecipeDialog, Recipe },
  name: 'RecipeBuilder',
  data() {
    return {
      maltCategories: [
        {name: "Grunnmalt"}, //0
        {name: "Kristal / Karamellu malt"}, //1
        {name: "Ristað malt"}, //2
        {name: "Flögur og ómaltað"}, //3
        {name: "Annað"}], //4
      ingredients: [],
      categories: [],
      recipeAlternatives: [],
      recipeAlternativesSelected: [],
      recipeFields: [
        {key: 'qty', label: 'Magn'},
        {key: 'name', label: 'Nafn'},
        {key: 'stock', label: 'Lager'},
        {key: 'type', label: 'Teg'},
        {key: 'price', label: 'Verð'}
      ],
    }
  },
  methods: {
    recipeChange: function(data) { // data is from recipeAlternatives.value

      data = this.handleQty(data)

      this.$set(this.$root.state.recipe, data.recipeIndex, data)
    },
    handleQty: function (item) { // If item isn't grain, we want whole numbers
      if (item.category > 4)
        item.qty = Math.ceil(item.qtyInput)
      else
        item.qty = item.qtyInput

      return item
    },
    processText: function (){
      this.$root.state.recipe = [];
      this.recipeAlternatives = [];
      this.recipeAlternativesSelected = [];
      if (this.$root.state.recipeText)
      {
        var that = this;
        this.$root.state.recipeText.split("\n").forEach(function (text, index) {
          if (text.length > 3)
          {
            // Vinna með streng - skipta í vigt og nafn (i,n)
            text = text.trim()
            var w = text.split(" ", 1)[0];
            var n = text.replace(w, '').trim();
            w = w.replace(',', '.');
            if (w > 100)
              w = Math.round(w/10)/100;

            const fuse = new Fuse(that.ingredients, {keys: [{name: "name", weight: 0.8}, {name: "aliases", weight: 0.5}], includeScore: true})
            const results = fuse.search(n, {limit: 10})

            that.recipeAlternatives[index] = [];
            results.forEach((item) => {
              // Kommur í punkta, rúnna í kg ef yfir 100
              let t = JSON.parse(JSON.stringify(item.item))
              //console.log(t)
              t.qtyInput = w
              t.qty = w
              t = that.handleQty(t)

              t.recipeIndex = index

              that.recipeAlternatives[index].push({text: t.name, qty: w, value:t}) // +Eg er að skrifa yfir ingredients listann alltaf. Laga það!
            })
            that.$set(that.$root.state.recipe, index, that.recipeAlternatives[index][0].value)
            that.$set(that.recipeAlternativesSelected, index, that.recipeAlternatives[index][0].value)
          }
        })

      }
    },
    categorifier: function (x){
      if (x.categories.includes(37)) // Ger
        return 8
      else if (x.categories.includes(36)) // Humall
        return 5
      else if (x.categories.includes(35)) // Korn
      {
        if (x.categories.includes(46)) // Ristað
          return 3
        if (x.categories.includes(45)) // Crystal
          return 2
        if (x.categories.includes(44)) // Grunn
          return 1

        return 4
      }
      else
        return 9
    },
    confirmOrder: function() {
      this.$refs['confirmModal'].show();
    },
    hideModal: function() {
      this.$refs['confirmModal'].hide();
    },
    getCat: function(cats) {
      var t = [];
      this.ingredients.forEach(function(v) {
        v.categories.forEach(function (c) {
          if (cats.includes(c))
            t.push(v);
        });
      })
      return t;
    },
    getIngredient: function(product_id) {
      this.ingredients.forEach((item) => {
        if (item.product_id == product_id)
          return item
      });
    },
    getStock: function(product_id) {
      return this.getIngredient(product_id).quantity > 0
    },
    dateDisabled (ymd, date)
    {
      const weekday = date.getDay();
      const weekends = weekday === 0 || weekday === 1 || weekday === 6; // No pickup on sunday, monday, saturday
      return weekends;
    }
  },
  computed: {
    cartTotal: function () {
      var t = 0
      this.$root.state.recipe.forEach(function(v) {
         t += v.price * v.qty
      })
      return Math.ceil(t)
    },
    outOfStock: function() {
      var b = false;
      this.$root.state.recipe.forEach((item) => {
        if (item.quantity < 1)
          b = true;
      });
      return b;
    },
    recipeGrainQty: function () { // How much grain in recipe
      let grainAmount = 0;
      this.$root.state.recipe.forEach(element => {
        if (element.categories.includes(35))
          grainAmount += parseFloat(element.qty)
      });
      return grainAmount
    },
    recipeCheck: function() { // Returns false if recipe is OK
      //if (this.$root.state.recipe.length == 0)
      //  return true

      if (this.recipeGrainQty == 0 || this.$root.state.recipe.length == 0)  // Every recipe includes grains
        return true

      return false
    }
  },
  created: function () {
    var that = this;
    fetch('https://www.brew.is/uppskriftir/getproducts.php')
      .then((resp) => resp.json())
      .then(function (response) {
        //console.log(typeof(response.ingredients))
        response.ingredients.forEach((item) => {
          item.category = that.categorifier(item);
          if (item.category < 5) // Mölun
            item.price += 50;
        });

        that.ingredients = response.ingredients;
        that.categories = response.categories;
      });
  },
  mounted: function () {
    if (this.$route.params.id)
      this.$refs['recipeModal'].show();

    // Change url when recipe modal is closed / hidden
    let that = this
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId == 'recipeModal')
        that.$router.push('/')
      //console.log('Modal is about to be hidden', bvEvent, modalId)
    })      
  },
  watch: {
    // Show recipe modal
    $route: function (to, ) {
      if (to.params.id)
        this.$refs['recipeModal'].show()
      //console.log(to,from)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* { text-align: left;}
.dot {
  height: 15px;
  width: 15px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}

.hopdot {
  background-color: green;
}
.yeastdot {
  background-color: yellow;
}
.graindot {
  background-color: #e8b200;
}

.warningdot {
  background-color: orange;
}
.greendot {
  background-color: green;
}
.errordot {
  background-color: red;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}
</style>
